export default [
  function () {
    const queryParams = (search) => {
      if (search[0] === '?') {
        search = search.substring(1);
      }

      if (!search) {
        return {};
      }

      const searchObject = {};

      search.split('&').forEach((item) => {
        const [key, value] = item.split('=');

        searchObject[key] = value;
      });

      return searchObject;
    };

    return {
      queryParams,
    };
  }
];
